/* eslint-disable react/no-unused-state */
/* eslint-disable consistent-return */
/* eslint-disable react/no-unused-class-component-methods */
/* eslint-disable no-lonely-if */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/sort-comp */
/* eslint-disable no-plusplus */
/* eslint-disable no-loop-func */
/* eslint-disable no-await-in-loop */
/* eslint-disable react/no-array-index-key */
/* eslint-disable eqeqeq */
/* eslint-disable object-curly-newline */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-restricted-globals */
import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import './css/ToursResult.css';
import { FallingLines, ThreeDots } from 'react-loader-spinner';
import { pick, keys } from 'lodash';
import {
  getToursSearchStatus,
  searchLong,
  initToursSearch,
  getToursSearchReustl,
  getHotelTypes,
} from '../../Utils/RestUtils';
import { ReactComponent as BlueStarIco } from '../../images/blue-star.svg';
import { ReactComponent as GrayStarIco } from '../../images/gray_star_17.svg';
import { ReactComponent as FilterIco } from '../../images/filter-r.svg';
import { ReactComponent as MapIco } from '../../images/map-r.svg';
import {
  changeDestination,
  changeDepartureDate,
  setNightsFrom,
  setNightsTo,
  setAdults,
  setKids,
  changeDepatureCity,
  changeSelectedResorts,
  changeTouristsSearchText,
  changeDatesSearchText,
} from '../../DataStore/actions/searchFormActions';
import {
  changeHotelsFilter,
  changeStarsFilter,
  changeStarsFilterHover,
  changeMealsFilter,
  changeRatingFilter,
  changeBeachLineFilter,
  changeBeachTypesFilter,
  changeHotelTypeFilter,
  changeHotelServicesFilter,
  changeOnlyCharter,
  changeDirectFlight,
  changeCurrency,
  changeRegionsOptions,
  changeIsAllRegionsFilterTab,
  changeOperatorsFilter,
  changeIsAllOperatorsTab,
  changeSelectedHotels,
} from '../../DataStore/actions/FiltersAction';
import {
  HOME_PAGE,
  TOUR_SEARCH_RESULT,
  HOTEL_CLASS,
  MEAL,
  RATING,
  RATING_3_5_PLUS,
  RATING_4_PLUS,
  RATING_4_5_PLUS,
  BEACH_LINE,
  RESORT,
  BEACH_TYPE,
  OPERATOR,
  HOTEL_TYPE,
  FIRST,
  VERY_GOOD,
  GOOD,
  PERFECT,
  CHARTER_ONLY,
  FLIGHT,
  CLEAR_FILTERS,
  SHOW,
  FILTERS,
  SEA_DIST,
  SEARC_PRICES,
  TOURS_NOT_FOUND,
  SYSTEM_FAULT,
  SEARCH_MORE,
  DIRECT_FLIGHT,
  SHOW_ON_MAP,
  HIDE_MAP,
  EXPAND_MAP,
} from '../../Utils/Constants/GlobalConstants';
import SearchFormFunc from '../SearchForm/SearchFormFunc';
import HotelsFilter from './HotelsFilter/HotelsFilter';
import ResortFilter from './ResortFilter/ResortFilter';
import {
  updateStateFromUrl,
  listOfObjectsWithIdToString,
  getSelectedRegionsAndSubregions,
  arrayToString,
  getHotelsCountText,
  getInHotelsCountText,
  getToursCount,
  firstLetterInUpperCase,
  getInitialSearchUrlObj,
  getShortString,
  formatPrice,
  getToursCountFromSearch,
  getDateText,
  getNightsText,
  getTouristsText,
} from '../../Utils/CommonUtils';
import {
  FROM_PARAM,
  TO_PARAM,
  DEPARTURE_FROM_PARAM,
  DEPARTURE_TO_PARAM,
  NIGHTS_FROM_PARAM,
  NIGHTS_TO_PARAM,
  ADULTS_PARAM,
  CURRENCY_PARAM,
  HOTELS_PARAM,
  HOTEL_PARAM,
  STARS_PARAM,
  RATING_PARAM,
  MEALS_PARAM,
  BEACH_LINE_PARAM,
  BEACH_TYPE_PARAM,
  HOTEL_TYPE_PARAM,
  OPERATORS_PARAM,
  SERVICES_PARAM,
  REGION_PARAM,
  SUBREGION_PARAM,
  CHARTER_ONLY_PARAM,
  DIRECT_PARAM,
  KIDS_AGES_PARAM,
} from '../../Utils/Constants/urlParams';
import { meals } from '../../Utils/Constants/Meals';
import { countryBounds } from '../../Utils/Constants/countries';
import { beachTypes } from '../../Utils/Constants/BeachTypes';
import {
  HOTEL,
  FOR_KIDS,
  ROOM,
  TERRITORY,
  DOP,
  services,
} from '../../Utils/Constants/Services';
import { getResortsByCountryIdAndThen } from '../../Utils/ElasticUtils';
import OperatorsFilter from './OperatorsFilter/OperatorsFilter';
import TourLoader from './TourLoader/TourLoader';
import HotelsMap from './HotelsMap/HotelsMap';
import { availableCurrencies } from '../../Utils/Constants/Currency';
import ProgressBar from '../ProgressBar/ProgressBar';
import SearchOptions from '../SearchOptions/SearchOptions';
import { ReactComponent as DefaultCheck } from '../../images/default-check-r.svg';
import { ReactComponent as ActiveCheck } from '../../images/active-check-r.svg';
import { ReactComponent as ResetFilters } from '../../images/reset-r.svg';
import { ReactComponent as OrangeStar } from '../../images/orange-star-r.svg';
import { ReactComponent as SeaWaves } from '../../images/sea-waves-r.svg';
import { ReactComponent as GRAY_PERSON } from '../../images/gray-person-r.svg';
import { ReactComponent as GRAY_CALENDAR } from '../../images/gray-calendar-r.svg';
import NoResults from '../../images/no-results.png';
import SearchMap from '../../images/map.svg';
import { ReactComponent as NoHotel } from '../../images/hotel-r.svg';
import { ReactComponent as Close } from '../../images/close-r.svg';
import { ReactComponent as Expand } from '../../images/expand-r.svg';
import { hotelTypeOptions } from '../../Utils/Constants/HotelTypes';
import CurrencySelector from '../CurrencySelector/CurrencySelector';
import PriceText from '../PriceText/PriceText';

const mapStateToProps = (state) => ({ ...state });
// keep in sync with the media query hiding .tr_map_w in ToursResult.css
const MAP_MODAL_MEDIA_QUERY = '(max-width: 1400px)';

class ToursResult extends React.Component {
  constructor(props) {
    super(props);
    this.fetchDataCounter = 0;
    this.isSearchScreenLeft = false;
    this.toursContainer = React.createRef();
    this.tablenFilterContainer = React.createRef();
    this.mapWrapper = React.createRef();
    this.mapModalMedia = window.matchMedia(MAP_MODAL_MEDIA_QUERY);

    this.state = {
      hotels: [],
      mealsOptions: meals,
      hotelsFromUrl: [],
      loading: false,
      isNextPageSpinnerVisible: false,
      currentCountryId: 0,

      requestId: 0,
      hotelsCount: 0,
      toursCount: 0,
      errorText: '',
      progress: 0,
      isProgressVisible: false,
      isCurrencyPopupVisible: false,
      isTableFiltersFisible: false,
      tabletFiltersHeight: 0,
      scrollbarWidth: 0,
      searchMorePage: -1,
      hotelTypesLoading: true,
      hotelTypes: [],
      isMapVisible: false,
      selectedMapHotel: null,
      isMapHotelCardVisible: false,
      mapFocus: null,
      isMapModalVisible: false,
      isMapExpanded: false,
    };
  }

  componentDidMount() {
    this.mapModalMedia.addEventListener('change', this.handleMapMediaChange);

    // wide screens: map column is opened by default
    if (!this.mapModalMedia.matches) {
      this.handleMapVisibility();
    }

    const {
      location,
      destination,
      countryFilter,
      departureDate,
      nightsFrom,
      nightsTo,
      adults,
      kids,
      changeDestination: changeDestinationAction,
      changeSelectedResorts: changeSelectedResortsAction,
      changeIsAllRegionsFilterTab: changeIsAllRegionsFilterTabAction,
      changeHotelsFilter: changeHotelsFilterAction,
      changeTouristsSearchText: changeTouristsSearchTextAction,
      changeDatesSearchText: changeDatesSearchTextAction,
    } = this.props;

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    // screen withd
    this.timeout(2000).then(() => {
      const scrollWidth =
        window.innerWidth - document.documentElement.clientWidth;

      this.setState({
        scrollbarWidth: scrollWidth,
      });
    });

    this.setState({
      currentCountryId: destination.id,
      tabletFiltersHeight: window.innerHeight * 0.8,
    });

    let payload;
    if (
      (location.state && location.state.location === HOME_PAGE) ||
      countryFilter
    ) {
      // clear state
      window.history.replaceState({}, document.title);

      // if (countryFilter) {
      //   this.toursContainer.current.scrollIntoView({
      //     behavior: 'smooth',
      //   });
      // }

      payload = this.getPayloadFromState();

      // landign setup
      if (countryFilter) {
        payload[TO_PARAM] = countryFilter.id;
        changeDestinationAction(countryFilter);

        // landing has no search form submit, so fill card texts from state
        changeTouristsSearchTextAction(getTouristsText(adults, kids.length));
        changeDatesSearchTextAction(
          `${getDateText(departureDate)} / ${getNightsText(
            nightsFrom,
            nightsTo,
          )}`,
        );

        if (payload[HOTELS_PARAM]) {
          payload[HOTELS_PARAM] = '';
          changeHotelsFilterAction([]);
        }

        // drop resorts left from previous search
        delete payload[REGION_PARAM];
        delete payload[SUBREGION_PARAM];
        changeSelectedResortsAction([]);
        changeIsAllRegionsFilterTabAction(true);
      }

      getResortsByCountryIdAndThen(
        countryFilter ? { ...this.props, selectedResorts: [] } : this.props,
        payload[TO_PARAM],
      );
    } else {
      payload = updateStateFromUrl(this.props);
    }

    this.fetchData(payload, ++this.fetchDataCounter);

    getHotelTypes(destination.id)
      .then((result) => {
        if (result && result.data) {
          this.setState({ hotelTypes: result.data });
        } else {
          this.setState({ hotelTypes: hotelTypeOptions });
        }
      })
      .catch(() => {
        this.setState({ hotelTypes: hotelTypeOptions });
      })
      .finally(() => {
        this.setState({ hotelTypesLoading: false });
      });
  }

  getInitialSearchPayload = () => {
    const {
      depatureCity,
      destination,
      departureDate,
      nightsFrom,
      nightsTo,
      adults,
      currency,
      kids,
    } = this.props;

    const payload = {
      [FROM_PARAM]: depatureCity.id,
      [TO_PARAM]: destination.id,
      [DEPARTURE_FROM_PARAM]: moment(departureDate.from).format('YYYY-MM-DD'),
      [DEPARTURE_TO_PARAM]: moment(departureDate.to).format('YYYY-MM-DD'),
      [NIGHTS_FROM_PARAM]: nightsFrom,
      [NIGHTS_TO_PARAM]: nightsTo,
      [ADULTS_PARAM]: adults,
      [CURRENCY_PARAM]: currency.id,
    };

    if (kids.length > 0) {
      payload[KIDS_AGES_PARAM] = arrayToString(kids.map((item) => item.age));
    }

    return payload;
  };

  getFiltersCount = () => {
    const {
      hotelsFilter,
      starsFilter,
      mealsFilter,
      ratingFilter,
      beachLineFilter,
      beachTypesFilter,
      hotelTypeFilter,
      hotelServicesFilter,
      onlyCharter,
      selectedResorts,
      operatorsFilter,
    } = this.props;

    let count = 0;

    if (hotelsFilter.length > 0) {
      count++;
    }

    if (starsFilter > 1) {
      count++;
    }

    if (mealsFilter && mealsFilter.id) {
      count++;
    }

    if (ratingFilter > 0) {
      count++;
    }

    if (beachLineFilter === 1) {
      count++;
    }

    if (beachTypesFilter.length > 0) {
      count++;
    }

    if (hotelTypeFilter.length > 0) {
      count++;
    }

    if (hotelServicesFilter.length > 0) {
      count++;
    }

    if (onlyCharter === 1) {
      count++;
    }

    if (selectedResorts.length > 0) {
      count++;
    }

    if (operatorsFilter.length > 0) {
      count++;
    }

    return count;
  };

  getPayloadFromState = () => {
    const {
      depatureCity,
      destination,
      departureDate,
      nightsFrom,
      nightsTo,
      adults,
      currency,
      hotelsFilter,
      starsFilter,
      mealsFilter,
      ratingFilter,
      beachLineFilter,
      beachTypesFilter,
      hotelTypeFilter,
      hotelServicesFilter,
      onlyCharter,
      directFlight,
      selectedResorts,
      operatorsFilter,
      kids,
    } = this.props;

    const payload = {
      [FROM_PARAM]: depatureCity.id,
      [TO_PARAM]: destination.id,
      [DEPARTURE_FROM_PARAM]: moment(departureDate.from).format('YYYY-MM-DD'),
      [DEPARTURE_TO_PARAM]: moment(departureDate.to).format('YYYY-MM-DD'),
      [NIGHTS_FROM_PARAM]: nightsFrom,
      [NIGHTS_TO_PARAM]: nightsTo,
      [ADULTS_PARAM]: adults,
      [CURRENCY_PARAM]: currency.id,
    };

    if (kids.length > 0) {
      payload[KIDS_AGES_PARAM] = arrayToString(kids.map((item) => item.age));
    }

    if (hotelsFilter.length > 0) {
      payload[HOTELS_PARAM] = listOfObjectsWithIdToString(hotelsFilter);
    }

    if (starsFilter > 1) {
      payload[STARS_PARAM] = starsFilter;
    }

    if (mealsFilter && mealsFilter.id) {
      payload[MEALS_PARAM] = mealsFilter.id;
    }

    if (ratingFilter > 0) {
      payload[RATING_PARAM] = ratingFilter;
    }

    if (beachLineFilter === 1) {
      payload[BEACH_LINE_PARAM] = beachLineFilter;
    }

    if (beachTypesFilter.length > 0) {
      payload[BEACH_TYPE_PARAM] = listOfObjectsWithIdToString(beachTypesFilter);
    }

    if (hotelTypeFilter.length > 0) {
      payload[HOTEL_TYPE_PARAM] = listOfObjectsWithIdToString(beachTypesFilter);
    }

    if (hotelServicesFilter.length > 0) {
      payload[SERVICES_PARAM] =
        listOfObjectsWithIdToString(hotelServicesFilter);
    }

    if (onlyCharter === 1) {
      payload[CHARTER_ONLY_PARAM] = 1;
    }

    if (directFlight === 1) {
      payload[DIRECT_PARAM] = 1;
    }

    if (selectedResorts.length > 0) {
      const reg = getSelectedRegionsAndSubregions(selectedResorts);

      payload[REGION_PARAM] = listOfObjectsWithIdToString(
        reg.filter((e) => e.type === 'region'),
      );

      payload[SUBREGION_PARAM] = listOfObjectsWithIdToString(
        reg.filter((e) => e.type === 'subregion'),
      );
    }

    if (operatorsFilter.length > 0) {
      payload[OPERATORS_PARAM] = listOfObjectsWithIdToString(operatorsFilter);
    }

    return payload;
  };

  clearAllFilters = () => {
    this.toursContainer.current.scrollIntoView({
      behavior: 'smooth',
    });

    this.clearFilters();
    this.fetchData(this.getInitialSearchPayload(), ++this.fetchDataCounter);
  };

  clearFilters = () => {
    const {
      navigate,
      location,
      changeHotelsFilter: changeHotelsFilterAction,
      changeSelectedHotels: changeSelectedHotelsAction,
      changeStarsFilter: changeStarsFilterAction,
      changeStarsFilterHover: changeStarsFilterHoverAction,
      changeMealsFilter: changeMealsFilterAction,
      changeRatingFilter: changeRatingFilterAction,
      changeBeachLineFilter: changeBeachLineFilterAction,
      changeBeachTypesFilter: changeBeachTypesFilterAction,
      changeHotelTypeFilter: changeHotelTypeFilterAction,
      changeHotelServicesFilter: changeHotelServicesFilterAction,
      changeOnlyCharter: changeOnlyCharterAction,
      changeDirectFlight: changeDirectFlightAction,
      changeSelectedResorts: changeSelectedResortsAction,
      changeOperatorsFilter: changeOperatorsFilterAction,
    } = this.props;

    const queryParameters = new URLSearchParams(location.search);

    changeHotelsFilterAction([]);
    changeSelectedHotelsAction([]);
    queryParameters.delete(HOTELS_PARAM);

    changeStarsFilterAction(1);
    changeStarsFilterHoverAction(1);
    queryParameters.delete(STARS_PARAM);

    changeMealsFilterAction({});
    queryParameters.delete(MEALS_PARAM);

    changeRatingFilterAction(0);
    queryParameters.delete(RATING_PARAM);

    changeBeachLineFilterAction(0);
    queryParameters.delete(BEACH_LINE_PARAM);

    changeBeachTypesFilterAction([]);
    queryParameters.delete(BEACH_TYPE_PARAM);

    changeHotelTypeFilterAction([]);
    queryParameters.delete(HOTEL_TYPE_PARAM);

    changeHotelServicesFilterAction([]);
    queryParameters.delete(SERVICES_PARAM);

    changeOnlyCharterAction(0);
    queryParameters.delete(CHARTER_ONLY_PARAM);

    changeDirectFlightAction(0);
    queryParameters.delete(DIRECT_PARAM);

    changeSelectedResortsAction([]);
    queryParameters.delete(REGION_PARAM);
    queryParameters.delete(SUBREGION_PARAM);

    changeOperatorsFilterAction([]);
    queryParameters.delete(OPERATORS_PARAM);

    navigate({
      pathname: '/search',
      search: queryParameters.toString(),
    });
  };

  componentWillUnmount() {
    const { isMapModalVisible } = this.state;

    this.isSearchScreenLeft = true;
    this.removeMapHeightListeners();
    this.mapModalMedia.removeEventListener('change', this.handleMapMediaChange);

    if (isMapModalVisible) {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  }

  handleMapVisibility = () => {
    this.setState(
      (prevState) => ({
        isMapVisible: !prevState.isMapVisible,
        selectedMapHotel: null,
      }),
      () => {
        const { isMapVisible } = this.state;

        if (isMapVisible) {
          window.addEventListener('scroll', this.updateMapHeight);
          window.addEventListener('resize', this.updateMapHeight);
          this.updateMapHeight();
        } else {
          this.removeMapHeightListeners();
        }
      },
    );
  };

  // narrow screens: map is shown in a modal instead of the right column
  handleMapModal = () => {
    const { isMapModalVisible, scrollbarWidth } = this.state;

    if (!isMapModalVisible) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }

    this.setState({
      isMapModalVisible: !isMapModalVisible,
      selectedMapHotel: null,
    });
  };

  // narrow map column is moved to the modal and comes back on close
  handleMapExpand = () => {
    this.handleMapVisibility();
    this.handleMapModal();
    this.setState({ isMapExpanded: true });
  };

  handleMapModalClose = () => {
    const { isMapExpanded } = this.state;

    this.handleMapModal();

    if (isMapExpanded && !this.mapModalMedia.matches) {
      this.handleMapVisibility();
    }

    this.setState({ isMapExpanded: false });
  };

  handleMapModalBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      this.handleMapModalClose();
    }
  };

  renderMap = () => {
    const { destination } = this.props;
    const { hotels, selectedMapHotel, isMapHotelCardVisible, mapFocus } =
      this.state;

    return (
      <>
        <HotelsMap
          hotels={hotels}
          countryBounds={countryBounds[destination.id]}
          focus={mapFocus}
          selectedHotelId={selectedMapHotel && selectedMapHotel.id}
          onHotelSelect={this.handleMapHotelSelect}
        />
        {selectedMapHotel &&
          isMapHotelCardVisible &&
          this.renderMapHotelCard(selectedMapHotel)}
      </>
    );
  };

  // preview opens the map column, or the modal when the column is hidden
  handleMapPreviewClick = () => {
    if (this.mapModalMedia.matches) {
      this.handleMapModal();
    } else {
      this.handleMapVisibility();
    }
  };

  // opened map moves between the right column and the modal on resize
  handleMapMediaChange = (e) => {
    const { isMapVisible, isMapModalVisible } = this.state;

    if (e.matches && isMapVisible) {
      this.handleMapVisibility();
      this.handleMapModal();
    } else if (!e.matches && isMapModalVisible) {
      this.handleMapModal();
      this.handleMapVisibility();
      this.setState({ isMapExpanded: false });
    }
  };

  removeMapHeightListeners = () => {
    window.removeEventListener('scroll', this.updateMapHeight);
    window.removeEventListener('resize', this.updateMapHeight);
  };

  // map fits the visible part of the window until it becomes sticky
  updateMapHeight = () => {
    const node = this.mapWrapper.current;

    if (node) {
      const top = Math.max(node.getBoundingClientRect().top, 0);
      node.style.height = `${window.innerHeight - top}px`;
    }
  };

  // hotel card is shown only after a click on the price on the map
  handleMapHotelSelect = (hotel) => {
    this.setState({ selectedMapHotel: hotel, isMapHotelCardVisible: !!hotel });
  };

  // with opened map a click on a hotel in the list shows it on the map
  handleHotelItemClick = (e, hotel) => {
    const { isMapVisible } = this.state;

    if (!isMapVisible || e.target.closest('.tr_price_w')) {
      return;
    }

    e.preventDefault();
    this.setState({
      selectedMapHotel: hotel,
      isMapHotelCardVisible: false,
      mapFocus: { hotel },
    });
  };

  renderMapHotelCard = (item) => (
    <div className="tr_map_card">
      {this.renderHotelItem(item, true)}
      <button
        type="button"
        className="tr_map_card_close"
        onClick={() => this.handleMapHotelSelect(null)}
      >
        <Close />
      </button>
    </div>
  );

  // stars
  renderStars = () => {
    const {
      starsFilter,
      starsFilterHover,
      changeStarsFilterHover: changeStarsFilterHoverAction,
    } = this.props;

    const stars = [];

    for (let i = 0; i < 5; i++) {
      if (i + 1 <= starsFilterHover) {
        stars.push(
          <button
            type="button"
            key={`star-${i}`}
            onClick={() => this.handleStarClick(i + 1)}
          >
            <BlueStarIco
              onMouseOver={() => changeStarsFilterHoverAction(i + 1)}
              onMouseOut={() => changeStarsFilterHoverAction(starsFilter)}
              className="tr_filter_category_star"
            />
          </button>,
        );
      } else {
        stars.push(
          <button
            type="button"
            key={`star-${i}`}
            onClick={() => this.handleStarClick(i + 1)}
          >
            <GrayStarIco
              className="tr_filter_category_star"
              onMouseOver={() => changeStarsFilterHoverAction(i + 1)}
              onMouseOut={() => changeStarsFilterHoverAction(starsFilter)}
            />
          </button>,
        );
      }
    }

    return stars;
  };

  handleStarClick = (hotelClass) => {
    const {
      changeStarsFilterHover: changeStarsFilterHoverAction,
      changeStarsFilter: changeStarsFilterAction,
      starsFilter,
      countryFilter,
    } = this.props;

    if (hotelClass !== starsFilter) {
      changeStarsFilterAction(hotelClass);
      changeStarsFilterHoverAction(hotelClass);

      if (countryFilter) {
        this.renderFilterQueryParam(STARS_PARAM, hotelClass);
      } else {
        this.renderFilterQueryParam(STARS_PARAM, hotelClass);
        const payload = this.getPayloadFromState();
        payload[STARS_PARAM] = hotelClass;

        this.fetchData(payload, ++this.fetchDataCounter);
      }
    }
  };

  // meals
  renderMealFilters = (mealsOptions) =>
    mealsOptions.map((item) => {
      const { mealsFilter } = this.props;
      return (
        <button
          key={`meal-${item.id}`}
          type="button"
          className="filter_description"
          onClick={() => this.handleMealsFilter(item)}
        >
          {mealsFilter && mealsFilter.id === item.id ? (
            <ActiveCheck className="tr_filter_check" />
          ) : (
            <DefaultCheck className="tr_filter_check" />
          )}
          <div>
            <span className="mealName">{item.name}</span>
            &nbsp;-&nbsp;{`${item.russian}`}
            <br />
            {item.description && (
              <span className="tr_meal_description">{`(${item.description})`}</span>
            )}
          </div>
        </button>
      );
    });

  handleMealsFilter = (mealOption) => {
    const {
      changeMealsFilter: changeMealsFilterAction,
      mealsFilter,
      countryFilter,
    } = this.props;

    if (countryFilter) {
      this.renderFilterQueryParam(MEALS_PARAM, mealOption.id);
    } else {
      let payload;
      if (mealsFilter === mealOption) {
        changeMealsFilterAction({});
        this.renderFilterQueryParam(MEALS_PARAM);
        payload = this.getPayloadFromState();

        payload = pick(
          payload,
          keys(payload).filter((key) => key !== MEALS_PARAM),
        );
      } else {
        changeMealsFilterAction(mealOption);
        this.renderFilterQueryParam(MEALS_PARAM, mealOption.id);
        payload = this.getPayloadFromState();
        payload[MEALS_PARAM] = mealOption.id;
      }

      this.fetchData(payload, ++this.fetchDataCounter);
    }

    this.toursContainer.current.scrollIntoView({
      behavior: 'smooth',
    });
  };

  // rating
  handleRatingFilter = (rating) => {
    const {
      changeRatingFilter: changeRatingFilterAction,
      ratingFilter,
      countryFilter,
    } = this.props;

    if (countryFilter) {
      this.renderFilterQueryParam(RATING_PARAM, rating);
    } else {
      let payload;
      if (rating === ratingFilter) {
        changeRatingFilterAction(0);
        this.renderFilterQueryParam(RATING_PARAM);

        payload = this.getPayloadFromState();
        payload = pick(
          payload,
          keys(payload).filter((key) => key !== RATING_PARAM),
        );
      } else {
        changeRatingFilterAction(rating);
        this.renderFilterQueryParam(RATING_PARAM, rating);

        payload = this.getPayloadFromState();
        payload[RATING_PARAM] = rating;
      }

      this.fetchData(payload, ++this.fetchDataCounter);
    }

    this.toursContainer.current.scrollIntoView({
      behavior: 'smooth',
    });
  };

  // beack line
  handleBeachLine = () => {
    const {
      changeBeachLineFilter: changeBeachLineFilterAction,
      beachLineFilter,
      countryFilter,
    } = this.props;

    if (countryFilter) {
      this.renderFilterQueryParam(BEACH_LINE_PARAM, 1);
    } else {
      let payload;
      if (beachLineFilter === 1) {
        changeBeachLineFilterAction(0);
        this.renderFilterQueryParam(BEACH_LINE_PARAM);
        payload = this.getPayloadFromState();
        payload = pick(
          payload,
          keys(payload).filter((key) => key !== BEACH_LINE_PARAM),
        );
      } else {
        changeBeachLineFilterAction(1);
        this.renderFilterQueryParam(BEACH_LINE_PARAM, 1);

        payload = this.getPayloadFromState();
        payload[BEACH_LINE_PARAM] = 1;
      }

      this.fetchData(payload, ++this.fetchDataCounter);
    }

    this.toursContainer.current.scrollIntoView({
      behavior: 'smooth',
    });
  };

  // beachType
  renderBeachTypeFilters = (beachTypesOptions) =>
    beachTypesOptions.map((item) => {
      const { beachTypesFilter } = this.props;
      const checked =
        beachTypesFilter.filter((e) => e.id === item.id).length === 1;

      return (
        <button
          key={`beachType-${item.id}`}
          type="button"
          className="filter_description"
          onClick={() => this.handleBeachTypeFilter(item)}
        >
          {checked ? (
            <ActiveCheck className="tr_filter_check" />
          ) : (
            <DefaultCheck className="tr_filter_check" />
          )}
          <div>{item.name}</div>
        </button>
      );
    });

  handleBeachTypeFilter = (beackTypeOption) => {
    const {
      changeBeachTypesFilter: changeBeachTypesFilterAction,
      beachTypesFilter,
      countryFilter,
    } = this.props;

    const isPresent =
      beachTypesFilter.filter((e) => e.id === beackTypeOption.id).length === 1;

    let newBeachTypeState;
    if (isPresent) {
      newBeachTypeState = beachTypesFilter.filter(
        (e) => e.id !== beackTypeOption.id,
      );
    } else {
      newBeachTypeState = beachTypesFilter.concat([beackTypeOption]);
    }

    changeBeachTypesFilterAction(newBeachTypeState);

    if (countryFilter) {
      this.renderFilterQueryParam(
        BEACH_TYPE_PARAM,
        listOfObjectsWithIdToString(newBeachTypeState),
      );
    } else {
      let payload;
      if (newBeachTypeState.length > 0) {
        this.renderFilterQueryParam(
          BEACH_TYPE_PARAM,
          listOfObjectsWithIdToString(newBeachTypeState),
        );

        payload = this.getPayloadFromState();
        payload[BEACH_TYPE_PARAM] =
          listOfObjectsWithIdToString(newBeachTypeState);
      } else {
        this.renderFilterQueryParam(BEACH_TYPE_PARAM);
        payload = this.getPayloadFromState();
        payload = pick(
          payload,
          keys(payload).filter((key) => key !== BEACH_TYPE_PARAM),
        );
      }

      this.fetchData(payload, ++this.fetchDataCounter);
    }

    this.toursContainer.current.scrollIntoView({
      behavior: 'smooth',
    });
  };

  // hotel type
  renderHotelTypesFilter = (hotelTypeOpt) =>
    hotelTypeOpt.map((item) => {
      const { hotelTypeFilter } = this.props;
      const checked =
        hotelTypeFilter.filter((e) => e.id === item.id).length === 1;

      return (
        <button
          key={`hotelType-${item.id}`}
          type="button"
          className="filter_description"
          onClick={() => this.handleHotelTypeFilter(item)}
        >
          {checked ? (
            <ActiveCheck className="tr_filter_check" />
          ) : (
            <DefaultCheck className="tr_filter_check" />
          )}
          <div>{item.name}</div>
        </button>
      );
    });

  handleHotelTypeFilter = (hotelTypeOption) => {
    const {
      changeHotelTypeFilter: changeHotelTypeFilterAction,
      hotelTypeFilter,
      countryFilter,
    } = this.props;

    const isPresent =
      hotelTypeFilter.filter((e) => e.id === hotelTypeOption.id).length === 1;

    let newHotelypeState;
    if (isPresent) {
      newHotelypeState = hotelTypeFilter.filter(
        (e) => e.id !== hotelTypeOption.id,
      );
    } else {
      newHotelypeState = hotelTypeFilter.concat([hotelTypeOption]);
    }

    changeHotelTypeFilterAction(newHotelypeState);

    if (countryFilter) {
      this.renderFilterQueryParam(
        HOTEL_TYPE_PARAM,
        listOfObjectsWithIdToString(newHotelypeState),
      );
    } else {
      let payload;
      if (newHotelypeState.length > 0) {
        this.renderFilterQueryParam(
          HOTEL_TYPE_PARAM,
          listOfObjectsWithIdToString(newHotelypeState),
        );

        payload = this.getPayloadFromState();
        payload[HOTEL_TYPE_PARAM] =
          listOfObjectsWithIdToString(newHotelypeState);
      } else {
        this.renderFilterQueryParam(HOTEL_TYPE_PARAM);
        payload = this.getPayloadFromState();
        payload = pick(
          payload,
          keys(payload).filter((key) => key !== HOTEL_TYPE_PARAM),
        );
      }

      this.fetchData(payload, ++this.fetchDataCounter);
    }

    this.toursContainer.current.scrollIntoView({
      behavior: 'smooth',
    });
  };

  // services
  renderHotelServicesFilter = (serviceOptions) =>
    serviceOptions.map((item) => {
      const { hotelServicesFilter } = this.props;
      const checked =
        hotelServicesFilter.filter((e) => e.id === item.id).length === 1;

      return (
        <button
          key={`service-${item.id}`}
          type="button"
          className="filter_description"
          onClick={() => this.handleServiceFilter(item)}
        >
          {checked ? (
            <ActiveCheck className="tr_filter_check" />
          ) : (
            <DefaultCheck className="tr_filter_check" />
          )}
          <div>{item.name}</div>
        </button>
      );
    });

  handleServiceFilter = (serviceOption) => {
    const {
      changeHotelServicesFilter: changeHotelServicesFilterAction,
      hotelServicesFilter,
      countryFilter,
    } = this.props;

    const isPresent =
      hotelServicesFilter.filter((e) => e.id === serviceOption.id).length === 1;

    let newState;
    if (isPresent) {
      newState = hotelServicesFilter.filter((e) => e.id !== serviceOption.id);
    } else {
      newState = hotelServicesFilter.concat([serviceOption]);
    }

    changeHotelServicesFilterAction(newState);

    if (countryFilter) {
      this.renderFilterQueryParam(
        SERVICES_PARAM,
        listOfObjectsWithIdToString(newState),
      );
    } else {
      let payload;
      if (newState.length > 0) {
        this.renderFilterQueryParam(
          SERVICES_PARAM,
          listOfObjectsWithIdToString(newState),
        );

        payload = this.getPayloadFromState();
        payload[SERVICES_PARAM] = listOfObjectsWithIdToString(newState);
      } else {
        this.renderFilterQueryParam(SERVICES_PARAM);

        payload = this.getPayloadFromState();
        payload = pick(
          payload,
          keys(payload).filter((key) => key !== SERVICES_PARAM),
        );
      }

      this.fetchData(payload, ++this.fetchDataCounter);
    }

    this.toursContainer.current.scrollIntoView({
      behavior: 'smooth',
    });
  };

  handleCharterFilter = () => {
    const {
      onlyCharter,
      changeOnlyCharter: changeOnlyCharterAction,
      countryFilter,
    } = this.props;

    if (countryFilter) {
      if (onlyCharter === 1) {
        this.renderFilterQueryParam(CHARTER_ONLY_PARAM, 0);
      } else {
        this.renderFilterQueryParam(CHARTER_ONLY_PARAM, 1);
      }
    } else {
      let payload;
      if (onlyCharter === 1) {
        changeOnlyCharterAction(0);
        this.renderFilterQueryParam(CHARTER_ONLY_PARAM);
        payload = this.getPayloadFromState();
        payload = pick(
          payload,
          keys(payload).filter((key) => key !== CHARTER_ONLY_PARAM),
        );
      } else {
        changeOnlyCharterAction(1);
        this.renderFilterQueryParam(CHARTER_ONLY_PARAM, 1);
        payload = this.getPayloadFromState();
        payload[CHARTER_ONLY_PARAM] = 1;
      }

      this.fetchData(payload, ++this.fetchDataCounter);
    }

    this.toursContainer.current.scrollIntoView({
      behavior: 'smooth',
    });
  };

  handleDirectFlightFilter = () => {
    const {
      directFlight,
      changeDirectFlight: changeDirectFlightAction,
      countryFilter,
    } = this.props;

    if (countryFilter) {
      if (directFlight === 1) {
        this.renderFilterQueryParam(DIRECT_PARAM, 0);
      } else {
        this.renderFilterQueryParam(DIRECT_PARAM, 1);
      }
    } else {
      let payload;
      if (directFlight === 1) {
        changeDirectFlightAction(0);
        this.renderFilterQueryParam(DIRECT_PARAM);
        payload = this.getPayloadFromState();
        payload = pick(
          payload,
          keys(payload).filter((key) => key !== DIRECT_PARAM),
        );
      } else {
        changeDirectFlightAction(1);
        this.renderFilterQueryParam(DIRECT_PARAM, 1);
        payload = this.getPayloadFromState();
        payload[DIRECT_PARAM] = 1;
      }

      this.fetchData(payload, ++this.fetchDataCounter);
    }

    this.toursContainer.current.scrollIntoView({
      behavior: 'smooth',
    });
  };

  handleRegionFilter = (newRegionState) => {
    const {
      navigate,
      location,
      changeSelectedResorts: changeSelectedResortsAcrtionAction,
      changeIsAllRegionsFilterTab: changeIsAllRegionsFilterTabAction,
      countryFilter,
    } = this.props;

    const selectedResorts = newRegionState.filter(
      (item) => item.checked === true,
    );

    changeSelectedResortsAcrtionAction(selectedResorts);

    if (countryFilter) {
      const selectedRegAndSubreg =
        getSelectedRegionsAndSubregions(selectedResorts);
      const reg = selectedRegAndSubreg.filter((e) => e.type === 'region');
      const subreg = selectedRegAndSubreg.filter((e) => e.type === 'subregion');

      if (reg.length > 0) {
        this.renderFilterQueryParam(
          REGION_PARAM,
          listOfObjectsWithIdToString(reg),
        );
      } else if (subreg.length > 0) {
        this.renderFilterQueryParam(
          SUBREGION_PARAM,
          listOfObjectsWithIdToString(subreg),
        );
      }
    } else {
      const queryParameters = new URLSearchParams(location.search);

      let payload = this.getPayloadFromState();

      if (selectedResorts.length === 0) {
        changeIsAllRegionsFilterTabAction(true);

        queryParameters.delete(REGION_PARAM);
        queryParameters.delete(SUBREGION_PARAM);

        payload = pick(
          payload,
          keys(payload).filter(
            (key) => key !== REGION_PARAM && key !== SUBREGION_PARAM,
          ),
        );
      } else {
        const selectedRegAndSubreg =
          getSelectedRegionsAndSubregions(selectedResorts);
        const reg = selectedRegAndSubreg.filter((e) => e.type === 'region');
        const subreg = selectedRegAndSubreg.filter(
          (e) => e.type === 'subregion',
        );

        queryParameters.delete(REGION_PARAM);
        if (reg.length > 0) {
          const param = listOfObjectsWithIdToString(reg);
          queryParameters.append(REGION_PARAM, param);
          payload[REGION_PARAM] = param;
        } else {
          payload = pick(
            payload,
            keys(payload).filter((key) => key !== REGION_PARAM),
          );
        }

        queryParameters.delete(SUBREGION_PARAM);
        if (subreg.length > 0) {
          const param = listOfObjectsWithIdToString(subreg);
          queryParameters.append(SUBREGION_PARAM, param);
          payload[SUBREGION_PARAM] = param;
        } else {
          payload = pick(
            payload,
            keys(payload).filter((key) => key !== SUBREGION_PARAM),
          );
        }
      }

      navigate({
        pathname: '/search',
        search: queryParameters.toString(),
      });

      this.fetchData(payload, ++this.fetchDataCounter);
    }
  };

  handleOperatorFilter = (newOperatorsState) => {
    const {
      changeIsAllOperatorsTab: changeIsAllOperatorsTabAction,
      countryFilter,
    } = this.props;

    if (countryFilter) {
      this.renderFilterQueryParam(
        OPERATORS_PARAM,
        listOfObjectsWithIdToString(newOperatorsState),
      );
    } else {
      let payload;
      if (newOperatorsState.length === 0) {
        this.renderFilterQueryParam(OPERATORS_PARAM);
        changeIsAllOperatorsTabAction(true);

        payload = this.getPayloadFromState();
        payload = pick(
          payload,
          keys(payload).filter((key) => key !== OPERATORS_PARAM),
        );
      } else {
        const param = listOfObjectsWithIdToString(newOperatorsState);

        this.renderFilterQueryParam(OPERATORS_PARAM, param);
        payload = this.getPayloadFromState();
        payload[OPERATORS_PARAM] = param;
      }

      this.fetchData(payload, ++this.fetchDataCounter);
    }
  };

  renderFilterQueryParam = (param, filter) => {
    const { navigate, location, countryFilter } = this.props;
    let queryParameters;

    if (countryFilter) {
      queryParameters = getInitialSearchUrlObj(this.props);

      if (filter && filter.toString().length > 0) {
        queryParameters.delete(param);
        queryParameters.append(param, filter);
      }
    } else {
      queryParameters = new URLSearchParams(location.search);

      if (queryParameters.get(param)) {
        queryParameters.delete(param);
      }

      if (filter && filter.toString().length > 0) {
        queryParameters.append(param, filter);
      }
    }

    navigate({
      pathname: '/search',
      search: queryParameters.toString(),
    });
  };

  searchMoreTours = () => {
    const { searchMorePage, requestId } = this.state;

    if (searchMorePage <= 2) {
      this.setState({ searchMorePage: searchMorePage + 1 });

      const payload = this.getPayloadFromState();
      searchLong(requestId).then((response) => {
        const { requestCount } = response.data;

        this.setState({ searchMorePage: requestCount });

        if (requestCount !== 0) {
          this.fetchData(payload, ++this.fetchDataCounter, requestId, true);
        }
      });
    }
  };

  handleCurrency = (value) => {
    const {
      currency,
      changeCurrency: changeCurrencyAction,
      countryFilter,
    } = this.props;
    if (currency.id !== value) {
      const newCurr = availableCurrencies.filter((e) => e.id === value)[0];

      changeCurrencyAction(newCurr);

      if (countryFilter) {
        this.renderFilterQueryParam(CURRENCY_PARAM, value.toString());
      } else {
        const payload = this.getPayloadFromState();
        payload[CURRENCY_PARAM] = value;
        this.renderFilterQueryParam(CURRENCY_PARAM, value.toString());

        this.fetchData(payload, ++this.fetchDataCounter);
      }
    }
  };

  fetchDataForm = () => {
    const {
      destination,
      changeIsAllRegionsFilterTab: changeIsAllRegionsFilterTabAction,
    } = this.props;
    const { currentCountryId } = this.state;

    let payload;
    if (currentCountryId !== destination.id) {
      this.setState({ currentCountryId: destination.id });

      this.clearFilters();

      payload = this.getInitialSearchPayload();
      getResortsByCountryIdAndThen(this.props, payload[TO_PARAM]);
      changeIsAllRegionsFilterTabAction(true);
    } else {
      payload = this.getPayloadFromState();
    }

    this.fetchData(payload, ++this.fetchDataCounter);
  };

  updateHotels = (hotels) => {
    const payload = this.getPayloadFromState();
    payload[HOTELS_PARAM] = listOfObjectsWithIdToString(hotels);

    this.fetchData(payload, ++this.fetchDataCounter);
  };

  renderHotelCategory = (starsCount) => {
    const content = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < starsCount; i++) {
      content.push(<OrangeStar key={i} className="tr_category_star" />);
    }
    return content;
  };

  getSearchCountText = () => {
    const { hotelsCount, toursCount } = this.state;

    let result = '';
    if (toursCount > 0 && hotelsCount > 0) {
      result = `${getToursCount(toursCount)} ${getInHotelsCountText(
        hotelsCount,
      )}`;
    } else if (toursCount == 0 && hotelsCount > 0) {
      result = getHotelsCountText(hotelsCount);
    } else if (toursCount > 0 && hotelsCount === 0) {
      result = getToursCount(toursCount);
    }

    return result;
  };

  getHotelLocationName = (hotel) => {
    let result = '';

    if (hotel.subRegion && hotel.subRegion.name) {
      result += `${hotel.subRegion.name}, `;
    }

    if (hotel.region && hotel.region.name) {
      result += `${hotel.region.name}, `;
    }

    if (hotel.country && hotel.country.name) {
      result += `${hotel.country.name}`;
    }

    return result;
  };

  isSeaDistancePresent = (seaDistanse) => seaDistanse && seaDistanse != 0;

  // a long hotel name takes more lines, so the description is shorter
  getHotelDescriptionLength = (item) => {
    const isLongName = !!item.name && item.name.length > 20;

    if (this.isSeaDistancePresent(item.seaDistance)) {
      return isLongName ? 35 : 70;
    }

    return isLongName ? 60 : 100;
  };

  // isMapCard: the same card shown over the map, links open the hotel as usual
  renderHotelItem = (item, isMapCard) => {
    const { touristsSearchText, datesSearchText } = this.props;
    const { isMapVisible } = this.state;
    const isMapFocusClick = isMapVisible && !isMapCard;

    const backgroundImage = {
      backgroundImage: `url("${item.picturelink}")`,
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
    };

    return (
      <div
        className={`tour_item ${isMapFocusClick ? 'c_pointer' : ''}`}
        onClick={
          isMapFocusClick ? (e) => this.handleHotelItemClick(e, item) : null
        }
        role="presentation"
      >
        <div className="tr_hotel_image_w">
          <Link
            className="tr_hotel_image_link"
            target="_blank"
            to={this.buildHotelDetailUrl(item.id)}
          >
            <NoHotel />
            <div style={backgroundImage} className="tr_hotel_img"></div>
          </Link>
        </div>

        <div className="tr_tour_info_w">
          <div className="tr_tour_info">
            <div className="tr_hotel_info_w2">
              <div className="tr_hotels_stars_w1">
                <div>{this.renderHotelCategory(item.category)}</div>
                <Link
                  target="_blank"
                  className="tr_hotel_name"
                  to={this.buildHotelDetailUrl(item.id)}
                >
                  {firstLetterInUpperCase(getShortString(item.name, 26))}
                </Link>
                <div className="tr_location">
                  {this.getHotelLocationName(item)}
                </div>
              </div>
              {item.rating > 0 && (
              <div
                className={`tr_hotel_raiting_w ${this.getRatingColor(
                  item.rating,
                )}`}
              >
                {item.rating}
              </div>
              )}
            </div>
            <div className="tr_hotel_description">
              <div
                dangerouslySetInnerHTML={{
                  __html: getShortString(
                    item.hotelDescription,
                    this.getHotelDescriptionLength(item),
                  ),
                }}
              />
            </div>
            <div className="tr_hotel_facilities">
              {this.isSeaDistancePresent(item.seaDistance) && (
              <div className="tr_sea_waves_w">
                <SeaWaves className="tr_sea_waves_ico" />
                <div>{`${SEA_DIST} ${item.seaDistance}м`}</div>
              </div>
              )}
            </div>
          </div>

          <div className="tr_tour_price_info">
            <div className="tr_tour_det_line_w">
              <div className="tr_tour_det_line">
                <div className="tr_tour_det_ico_w">
                  <GRAY_PERSON />
                </div>
                {touristsSearchText}
              </div>
              <div className="tr_tour_det_line">
                <div className="tr_tour_det_ico_w">
                  <GRAY_CALENDAR />
                </div>

                <div>{datesSearchText}</div>
              </div>
            </div>
            <Link
              target="_blank"
              className="tr_price_w blue_button"
              to={this.buildHotelDetailUrl(item.id)}
            >
              <div className="tr_price">
                <PriceText
                  text={`от ${formatPrice(item.price)} ${item.currency}`}
                />
              </div>
            </Link>
          </div>
        </div>
      </div>
    );
  };

  renderHotels = (hotels) =>
    hotels.map((item) => (
      <div key={`hotel-${item.id}`}>{this.renderHotelItem(item, false)}</div>
    ));

  buildHotelDetailUrl = (hotelId) => {
    const {
      destination,
      depatureCity,
      departureDate,
      nightsFrom,
      nightsTo,
      adults,
      kids,
      onlyCharter,
      directFlight,
      currency,
      mealsFilter,
    } = this.props;

    const queryParameters = new URLSearchParams();

    queryParameters.append(FROM_PARAM, depatureCity.id);
    queryParameters.append(TO_PARAM, destination.id);
    queryParameters.append(
      DEPARTURE_FROM_PARAM,
      departureDate.from ? moment(departureDate.from).format('YYYY-MM-DD') : '',
    );
    queryParameters.append(
      DEPARTURE_TO_PARAM,
      departureDate.to ? moment(departureDate.to).format('YYYY-MM-DD') : '',
    );
    queryParameters.append(NIGHTS_FROM_PARAM, nightsFrom);
    queryParameters.append(NIGHTS_TO_PARAM, nightsTo);
    queryParameters.append(ADULTS_PARAM, adults);
    queryParameters.append(CURRENCY_PARAM, currency.id);

    if (kids.length > 0) {
      queryParameters.append(
        KIDS_AGES_PARAM,
        arrayToString(kids.map((item) => item.age)),
      );
    }

    queryParameters.append(HOTEL_PARAM, hotelId);

    if (mealsFilter && mealsFilter.id) {
      queryParameters.append(MEALS_PARAM, mealsFilter.id);
    }

    if (onlyCharter === 1) {
      queryParameters.append(CHARTER_ONLY_PARAM, onlyCharter);
    }

    if (directFlight === 1) {
      queryParameters.append(DIRECT_PARAM, directFlight);
    }

    return `/hotel?${queryParameters.toString()}`;
  };

  getRatingColor = (rating) => {
    let result = '';
    if (rating <= 2) {
      result = 'tr_rating_red';
    } else if (rating <= 3.9) {
      result = 'tr_rating_yellow';
    } else {
      result = 'tr_rating_green';
    }

    return result;
  };

  getTimeout = (count) => {
    let result;
    if (count <= 3) {
      result = 2000;
    } else if (count <= 5) {
      result = 3000;
    } else {
      result = 5000;
    }

    return result;
  };

  async fetchData(payload, fetchDataCounter, currentRequestId, isMoreSearch) {
    const localFetchDataCounter = fetchDataCounter;
    let isError = false;
    let localProgress = 0;
    let requestId;

    this.setState({
      errorText: '',
      isProgressVisible: true,
    });

    if (isMoreSearch) {
      this.setState({
        progress: 70,
      });

      localProgress = 70;
    } else {
      this.setState({
        hotels: [],
        selectedMapHotel: null,
        loading: true,
        requestId: '',
        toursCount: 0,
        hotelsCount: 0,
        progress: 5,
      });
    }

    if (currentRequestId) {
      requestId = currentRequestId;
    } else {
      const requestIdResponse = await initToursSearch(payload).catch(() => {
        isError = true;
        this.setState({
          errorText: SYSTEM_FAULT,
          loading: false,
          isProgressVisible: false,
        });
      });

      if (!isError && requestIdResponse && requestIdResponse.data) {
        requestId = requestIdResponse.data.searchId;
        this.setState({ requestId });
      }
    }

    if (!isError && requestId) {
      const counterLimit = 30;
      let counter = 0;
      let searchProcess = 0;
      let foundedHotels = [];
      let completedCount = 0;

      while (
        searchProcess !== 100 &&
        counter < counterLimit &&
        !this.isSearchScreenLeft &&
        localFetchDataCounter === this.fetchDataCounter
      ) {
        isError = false;
        counter++;

        await this.timeout(this.getTimeout(counter));

        // check request id
        const statusResponse = await getToursSearchStatus(requestId).catch(
          () => {
            isError = true;

            if (completedCount === 0) {
              this.setState({ errorText: SYSTEM_FAULT, loading: false });
            }
          },
        );

        if (
          !isError &&
          statusResponse &&
          statusResponse.data &&
          statusResponse.data.operatorStatus &&
          localFetchDataCounter === this.fetchDataCounter
        ) {
          const { progress, operatorStatus } = statusResponse.data;
          searchProcess = progress;

          const newCompletedCount = operatorStatus.filter(
            (e) => e.status === 'complete',
          ).length;

          if (searchProcess > localProgress) {
            localProgress = searchProcess;
            this.setState({ progress: localProgress });
          } else if (localProgress < 90) {
            localProgress += 1;
            this.setState({ progress: localProgress });
          }

          if (newCompletedCount > completedCount && requestId != 0) {
            completedCount = newCompletedCount;

            const toursResult = await getToursSearchReustl(requestId).catch(
              () => {
                isError = true;

                if (completedCount === 0) {
                  this.setState({ errorText: SYSTEM_FAULT, loading: false });
                }
              },
            );

            if (
              !isError &&
              toursResult &&
              toursResult.data &&
              localFetchDataCounter === this.fetchDataCounter
            ) {
              if (toursResult.data.length > 0) {
                foundedHotels = toursResult.data;

                // a failed status request may be followed by a successful one
                this.setState({
                  errorText: '',
                  loading: false,
                  hotels: toursResult.data,
                  hotelsCount: toursResult.data.length,
                  toursCount: getToursCountFromSearch(toursResult.data),
                });
              }
            }
          }
        }
      }

      // outdated search or search screen left
      if (
        localFetchDataCounter !== this.fetchDataCounter ||
        this.isSearchScreenLeft
      ) {
        return;
      }

      if (searchProcess === 100 && !isMoreSearch) {
        const searchMoreResponse = await searchLong(requestId);

        if (
          localFetchDataCounter !== this.fetchDataCounter ||
          this.isSearchScreenLeft
        ) {
          return;
        }

        if (searchMoreResponse && searchMoreResponse.data) {
          const { requestCount } = searchMoreResponse.data;

          this.setState({ searchMorePage: requestCount });

          if (requestCount !== 0) {
            this.fetchData(payload, ++this.fetchDataCounter, requestId, true);
          } else {
            // stop searching
            if (searchProcess === 100 || counter === counterLimit) {
              this.setState({ progress: 100 });

              this.timeout(1000).then(() => {
                this.setState({ isProgressVisible: false });
              });
            }

            // handle empty result
            const { hotels } = this.state;
            if (foundedHotels.length === 0 && hotels.length === 0) {
              this.setState({
                errorText: TOURS_NOT_FOUND,
                loading: false,
                searchMorePage: 0,
              });
            }
          }
        } else {
          this.setState({ progress: 100 });

          this.timeout(1000).then(() => {
            this.setState({ isProgressVisible: false });
          });
        }
      } else {
        // stop searching
        if (searchProcess === 100 || counter === counterLimit) {
          this.setState({ progress: 100 });

          this.timeout(1000).then(() => {
            this.setState({ isProgressVisible: false });
          });
        }

        // handle empty result
        const { hotels } = this.state;
        if (foundedHotels.length === 0 && hotels.length === 0) {
          this.setState({
            errorText: TOURS_NOT_FOUND,
            loading: false,
            searchMorePage: 0,
          });
        }
      }
    }
  }

  async timeout(delay) {
    return new Promise((res) => {
      setTimeout(res, delay);
    });
  }

  handleModalClick = () => {
    const { isTableFiltersFisible, scrollbarWidth } = this.state;

    this.tablenFilterContainer.current.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    if (!isTableFiltersFisible) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      document.addEventListener('click', this.handleModalOutsideClick, false);
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      document.removeEventListener(
        'click',
        this.handleModalOutsideClick,
        false,
      );
    }

    this.setState({ isTableFiltersFisible: !isTableFiltersFisible });
  };

  handleModalOutsideClick = (e) => {
    const { className } = e.target;
    const isSVG =
      e.target.getAttribute('fill') !== null ||
      e.target.getAttribute('width') !== null;

    if (
      this.buttomSheetNode.contains(e.target) ||
      this.filterButtomNode.contains(e.target) ||
      this.tabletClearNode.contains(e.target) ||
      className === 'selected_hotel_clear' ||
      isSVG
    ) {
      return;
    }

    this.handleModalClick();
  };

  isSearchMoreAvailabel = () => {
    const { searchMorePage, loading, isProgressVisible } = this.state;

    return (
      !loading &&
      searchMorePage != 0 &&
      searchMorePage < 3 &&
      !isProgressVisible
    );
  };

  isSearchStarting = () => {
    const { isProgressVisible, hotels, errorText } = this.state;

    return isProgressVisible && hotels.length === 0 && errorText.length === 0;
  };

  // no search indicators while an error is shown
  isSearchinMoreVisible = () => {
    const { isProgressVisible, loading, errorText } = this.state;

    return !loading && isProgressVisible && errorText.length === 0;
  };

  render() {
    const {
      hotels,
      mealsOptions,
      hotelsFromUrl,
      loading,
      errorText,
      progress,
      isProgressVisible,
      isTableFiltersFisible,
      tabletFiltersHeight,
      hotelTypes,
      hotelTypesLoading,
      isMapVisible,
      isMapModalVisible,
    } = this.state;

    const {
      location,
      onlyCharter,
      text,
      navigate,
      mealsFilter,
      ratingFilter,
      beachLineFilter,
      destination,
      countryFilter,
      directFlight,
    } = this.props;

    const filtersCount = this.getFiltersCount();

    return (
      <div className="content">
        <div className="tr_intro">
          <div className="containerW">
            <div className="intro_inner">
              <SearchOptions />
              <SearchFormFunc
                page={TOUR_SEARCH_RESULT}
                search={() => this.fetchDataForm()}
                isDisabled={loading}
              />
            </div>

            <div className="tr_progress_w">
              {isProgressVisible && <ProgressBar progress={progress} />}
            </div>
          </div>
        </div>
        <div className="tr_tablet_panel">
          <button
            type="button"
            onClick={this.handleModalClick}
            className="tr_tablet_filter_buttom"
            ref={(node) => {
              this.filterButtomNode = node;
            }}
          >
            <FilterIco className="tr_filter_ico" />
            <div className="br_text_14">{FILTERS}</div>
          </button>
          <button
            type="button"
            className="tr_tablet_map_button"
            onClick={this.handleMapModal}
          >
            <MapIco className="tr_filter_ico" />
            <div className="br_text_14">{SHOW_ON_MAP}</div>
          </button>
        </div>
        <div
          className={`containerW tr_container ${
            isMapVisible ? 'tr_container_map' : ''
          }`}
          ref={this.toursContainer}
        >
          <div className="tr_wrapper">
            {/* Filters bar */}
            <div className="tr_left_bar_wrapper">
              <div
                className="tr_map_preview"
                style={{ backgroundImage: `url(${SearchMap})` }}
              >
                <button
                  type="button"
                  className="tr_map_button br_text_16"
                  onClick={this.handleMapPreviewClick}
                >
                  {isMapVisible ? HIDE_MAP : SHOW_ON_MAP}
                </button>
              </div>
              <div className="tr_left_bar">
                {loading && <div className="tr_filters_dis"></div>}

                {/* hotels */}
                <HotelsFilter
                  updateHotels={this.updateHotels}
                  hotelsFromUrl={hotelsFromUrl}
                  location={location}
                  navigate={navigate}
                  countryLanding={countryFilter}
                />

                {/* stars */}
                <div className="filter_item">
                  <div className="line_filter_title_w">
                    <div className="bm_text_16">{HOTEL_CLASS}</div>
                    <div>{this.renderStars()}</div>
                  </div>
                </div>

                {/* meal */}
                <div className="filter_item">
                  <div className="line_filter_title_w mb_7">
                    <div className="bm_text_16">{MEAL}</div>
                    {mealsFilter.name && (
                      <div className="meal_selected_name">{`${mealsFilter.name} и лучше`}</div>
                    )}
                  </div>
                  {this.renderMealFilters(mealsOptions)}
                </div>

                {/* beach line */}
                <div className="filter_item">
                  <div className="bm_text_16 mb_7">{BEACH_LINE}</div>
                  <button
                    type="button"
                    className="filter_description"
                    onClick={this.handleBeachLine}
                  >
                    {beachLineFilter === 1 ? (
                      <ActiveCheck className="tr_filter_check" />
                    ) : (
                      <DefaultCheck className="tr_filter_check" />
                    )}
                    <div>{FIRST}</div>
                  </button>
                </div>

                {/* rating */}
                <div className="filter_item">
                  <div className="bm_text_16 mb_7">{RATING}</div>
                  <button
                    type="button"
                    className="filter_description"
                    onClick={() => this.handleRatingFilter(5)}
                  >
                    {ratingFilter === 5 ? (
                      <ActiveCheck className="tr_filter_check" />
                    ) : (
                      <DefaultCheck className="tr_filter_check" />
                    )}
                    <div className="rating_description">
                      <div className="tr_rating_value">{RATING_4_5_PLUS}</div>
                      <div className="tr_rating_comment">{PERFECT}</div>
                    </div>
                  </button>
                  <button
                    type="button"
                    className="filter_description"
                    onClick={() => this.handleRatingFilter(4)}
                  >
                    {ratingFilter === 4 ? (
                      <ActiveCheck className="tr_filter_check" />
                    ) : (
                      <DefaultCheck className="tr_filter_check" />
                    )}
                    <div className="rating_description">
                      <div className="tr_rating_value">{RATING_4_PLUS}</div>
                      <div className="tr_rating_comment">{VERY_GOOD}</div>
                    </div>
                  </button>
                  <button
                    type="button"
                    className="filter_description"
                    onClick={() => this.handleRatingFilter(3)}
                  >
                    {ratingFilter === 3 ? (
                      <ActiveCheck className="tr_filter_check" />
                    ) : (
                      <DefaultCheck className="tr_filter_check" />
                    )}
                    <div className="rating_description">
                      <div className="tr_rating_value">{RATING_3_5_PLUS}</div>
                      <div className="tr_rating_comment">{GOOD}</div>
                    </div>
                  </button>
                </div>

                {/* flight */}
                <div className="filter_item">
                  <div className="bm_text_16 mb_7">{FLIGHT}</div>
                  <button
                    type="button"
                    className="filter_description"
                    onClick={this.handleDirectFlightFilter}
                  >
                    {directFlight === 1 ? (
                      <ActiveCheck className="tr_filter_check" />
                    ) : (
                      <DefaultCheck className="tr_filter_check" />
                    )}
                    <div>{DIRECT_FLIGHT}</div>
                  </button>
                  <button
                    type="button"
                    className="filter_description"
                    onClick={this.handleCharterFilter}
                  >
                    {onlyCharter === 1 ? (
                      <ActiveCheck className="tr_filter_check" />
                    ) : (
                      <DefaultCheck className="tr_filter_check" />
                    )}
                    <div>{CHARTER_ONLY}</div>
                  </button>
                </div>

                {/* resrots */}
                <div className="filter_item">
                  <div className="bm_text_16 mb_14">{RESORT}</div>
                  <ResortFilter
                    countryId={destination.id}
                    handleRegionFilter={this.handleRegionFilter}
                  />
                </div>

                {/* beach type */}
                <div className="filter_item">
                  <div className="bm_text_16 mb_7">{BEACH_TYPE}</div>
                  {this.renderBeachTypeFilters(beachTypes)}
                </div>

                {/* hotel type */}
                <div className="filter_item">
                  <div className="bm_text_16 mb_7">{HOTEL_TYPE}</div>
                  {hotelTypesLoading ? (
                    <div>
                      <ThreeDots
                        visible={hotelTypesLoading}
                        height="30"
                        width="30"
                        color="rgba(0, 0, 0, .3)"
                        radius="5"
                        ariaLabel="three-dots-loading"
                        wrapperClass="tr_three_dots"
                      />
                    </div>
                  ) : (
                    this.renderHotelTypesFilter(hotelTypes)
                  )}
                </div>

                {/* operators */}
                <div className="filter_item">
                  <div className="bm_text_16 mb_14">{OPERATOR}</div>
                  <OperatorsFilter
                    handleOperatorFilter={this.handleOperatorFilter}
                  />
                </div>

                {/* hotel */}
                <div className="filter_item">
                  <div className="bm_text_16 mb_7">{HOTEL}</div>
                  {this.renderHotelServicesFilter(
                    services.filter((e) => e.group === HOTEL),
                  )}
                </div>

                {/* for kids */}
                <div className="filter_item">
                  <div className="bm_text_16 mb_7">{FOR_KIDS}</div>
                  {this.renderHotelServicesFilter(
                    services.filter((e) => e.group === FOR_KIDS),
                  )}
                </div>

                {/* room */}
                <div className="filter_item">
                  <div className="bm_text_16 mb_7">{ROOM}</div>
                  {this.renderHotelServicesFilter(
                    services.filter((e) => e.group === ROOM),
                  )}
                </div>

                {/* territory */}
                <div className="filter_item">
                  <div className="bm_text_16 mb_7">{TERRITORY}</div>
                  {this.renderHotelServicesFilter(
                    services.filter((e) => e.group === TERRITORY),
                  )}
                </div>

                {/* dop filters */}
                <div className="filter_item">
                  <div className="bm_text_16 mb_7">{DOP}</div>
                  {this.renderHotelServicesFilter(
                    services.filter((e) => e.group === DOP),
                  )}
                </div>
                {filtersCount > 0 && (
                  <button
                    className="tr_clear_filters"
                    type="button"
                    onClick={this.clearAllFilters}
                  >
                    <ResetFilters className="tr_clear_icon" />
                    {`${CLEAR_FILTERS} (${filtersCount})`}
                  </button>
                )}
              </div>
            </div>
            <div className="tr_right_bar">
              <div className="tr_right_bar_line">
                <div className="hd_hotels_found">
                  {this.isSearchStarting() ? (
                    <div>{SEARC_PRICES}</div>
                  ) : (
                    <div className="tr_serch_resu_line">
                      <div>{this.getSearchCountText()}</div>
                      <div>
                        <ThreeDots
                          visible={isProgressVisible && errorText.length === 0}
                          height="30"
                          width="30"
                          color="rgba(0, 0, 0, .3)"
                          radius="5"
                          ariaLabel="three-dots-loading"
                          wrapperClass="tr_three_dots"
                        />
                      </div>
                    </div>
                  )}
                </div>
                <CurrencySelector handleCurrency={this.handleCurrency} />
              </div>
              {errorText.length > 0 && (
                <div className="tr_not_found_w">
                  <div className="tr_not_found">
                    <img src={NoResults} alt="" className="mb_5" />
                    <div className="br_text_18">{errorText}</div>
                  </div>
                </div>
              )}

              {loading && (
                <div>
                  <TourLoader />
                  <TourLoader />
                  <TourLoader />
                  <TourLoader />
                  <TourLoader />
                  <TourLoader />
                </div>
              )}

              {this.renderHotels(hotels)}

              {this.isSearchMoreAvailabel() && (
                <div className="show_more_wrapp">
                  <button
                    type="button"
                    className="search_more_btn"
                    onClick={this.searchMoreTours}
                    disabled={isProgressVisible}
                  >
                    <span className="nextPageText">{SEARCH_MORE}</span>
                  </button>
                </div>
              )}

              {this.isSearchinMoreVisible() && (
                <div className="show_more_wrapp">
                  <div className="search_more_btn_dis">
                    <span className="nextPageTextDis">{SEARC_PRICES}</span>
                    <FallingLines
                      color="rgba(0, 0, 0, .5)"
                      width="30"
                      visible
                      ariaLabel="falling-circles-loading"
                    />
                  </div>
                </div>
              )}
            </div>
            {isMapVisible && (
              <div className="tr_map_w" ref={this.mapWrapper}>
                {this.renderMap()}
                <button
                  type="button"
                  className="tr_map_expand"
                  title={EXPAND_MAP}
                  onClick={this.handleMapExpand}
                >
                  <Expand />
                </button>
              </div>
            )}
          </div>
        </div>
        {isMapModalVisible && (
          <div
            className="tr_map_modal"
            onClick={this.handleMapModalBackdropClick}
            role="presentation"
          >
            <div className="tr_map_modal_inner">
              {this.renderMap()}
              <button
                type="button"
                className="tr_map_modal_close"
                onClick={this.handleMapModalClose}
              >
                <Close />
              </button>
            </div>
          </div>
        )}
        <div
          className={`bottom-sheet-container ${
            isTableFiltersFisible ? 'tr_open' : ''
          }`}
        >
          <div
            className="bottom-sheet"
            style={{ height: `${tabletFiltersHeight}px` }}
            ref={(node) => {
              this.buttomSheetNode = node;
            }}
          >
            <div className="tr_bottom_sheet_title_line">
              <div className="bm_text_22 bm_20">{FILTERS}</div>
              <button type="button" onClick={this.handleModalClick}>
                <Close />
              </button>
            </div>

            <div
              className="tr_tablet_filters_w blue_scroll_container"
              style={{ height: `${tabletFiltersHeight - 70 - 68}px` }}
              ref={this.tablenFilterContainer}
            >
              {loading && <div className="tr_filters_dis_tablet"></div>}

              {/* hotels */}
              <HotelsFilter
                updateHotels={this.updateHotels}
                hotelsFromUrl={hotelsFromUrl}
                location={location}
                navigate={navigate}
                countryLanding={countryFilter}
              />

              {/* stars */}
              <div className="filter_item">
                <div className="line_filter_title_w">
                  <div className="bm_text_16">{HOTEL_CLASS}</div>
                  <div>{this.renderStars()}</div>
                </div>
              </div>

              {/* meal */}
              <div className="filter_item">
                <div className="line_filter_title_w mb_7">
                  <div className="bm_text_16">{MEAL}</div>
                  {mealsFilter.name && (
                    <div className="meal_selected_name">{`${mealsFilter.name} и лучше`}</div>
                  )}
                </div>
                {this.renderMealFilters(mealsOptions)}
              </div>

              {/* beach line */}
              <div className="filter_item">
                <div className="bm_text_16 mb_7">{BEACH_LINE}</div>
                <button
                  type="button"
                  className="filter_description"
                  onClick={this.handleBeachLine}
                >
                  {beachLineFilter === 1 ? (
                    <ActiveCheck className="tr_filter_check" />
                  ) : (
                    <DefaultCheck className="tr_filter_check" />
                  )}
                  <div>{FIRST}</div>
                </button>
              </div>

              {/* rating */}
              <div className="filter_item">
                <div className="bm_text_16 mb_7">{RATING}</div>
                <div className="tr_tablet_rating_w">
                  <button
                    type="button"
                    className="filter_description tr_tablet_rating_item"
                    onClick={() => this.handleRatingFilter(5)}
                  >
                    {ratingFilter === 5 ? (
                      <ActiveCheck className="tr_filter_check" />
                    ) : (
                      <DefaultCheck className="tr_filter_check" />
                    )}
                    <div className="rating_description">
                      <div className="tr_rating_value">{RATING_4_5_PLUS}</div>
                      <div className="tr_rating_comment">{PERFECT}</div>
                    </div>
                  </button>
                  <button
                    type="button"
                    className="filter_description tr_tablet_rating_item"
                    onClick={() => this.handleRatingFilter(4)}
                  >
                    {ratingFilter === 4 ? (
                      <ActiveCheck className="tr_filter_check" />
                    ) : (
                      <DefaultCheck className="tr_filter_check" />
                    )}
                    <div className="rating_description">
                      <div className="tr_rating_value">{RATING_4_PLUS}</div>
                      <div className="tr_rating_comment">{VERY_GOOD}</div>
                    </div>
                  </button>
                  <button
                    type="button"
                    className="filter_description tr_tablet_rating_item"
                    onClick={() => this.handleRatingFilter(3)}
                  >
                    {ratingFilter === 3 ? (
                      <ActiveCheck className="tr_filter_check" />
                    ) : (
                      <DefaultCheck className="tr_filter_check" />
                    )}
                    <div className="rating_description">
                      <div className="tr_rating_value">{RATING_3_5_PLUS}</div>
                      <div className="tr_rating_comment">{GOOD}</div>
                    </div>
                  </button>
                </div>
              </div>

              {/* flight */}
              <div className="filter_item">
                <div className="bm_text_16 mb_7">{FLIGHT}</div>
                <button
                  type="button"
                  className="filter_description"
                  onClick={this.handleDirectFlightFilter}
                >
                  {directFlight === 1 ? (
                    <ActiveCheck className="tr_filter_check" />
                  ) : (
                    <DefaultCheck className="tr_filter_check" />
                  )}
                  <div>{DIRECT_FLIGHT}</div>
                </button>
                <button
                  type="button"
                  className="filter_description"
                  onClick={this.handleCharterFilter}
                >
                  {onlyCharter === 1 ? (
                    <ActiveCheck className="tr_filter_check" />
                  ) : (
                    <DefaultCheck className="tr_filter_check" />
                  )}
                  <div>{CHARTER_ONLY}</div>
                </button>
              </div>

              {/* resrots */}
              <div className="filter_item">
                <div className="bm_text_16 mb_14">{RESORT}</div>
                <ResortFilter
                  countryId={destination.id}
                  handleRegionFilter={this.handleRegionFilter}
                />
              </div>

              {/* beach type */}
              <div className="filter_item">
                <div className="bm_text_16 mb_7">{BEACH_TYPE}</div>
                {this.renderBeachTypeFilters(beachTypes)}
              </div>

              {/* hotel type */}
              <div className="filter_item">
                <div className="bm_text_16 mb_7">{HOTEL_TYPE}</div>
                {hotelTypesLoading ? (
                  <div>
                    <ThreeDots
                      visible={hotelTypesLoading}
                      height="30"
                      width="30"
                      color="rgba(0, 0, 0, .3)"
                      radius="5"
                      ariaLabel="three-dots-loading"
                      wrapperClass="tr_three_dots"
                    />
                  </div>
                ) : (
                  this.renderHotelTypesFilter(hotelTypes)
                )}
              </div>

              {/* operators */}
              <div className="filter_item">
                <div className="bm_text_16 mb_14">{OPERATOR}</div>
                <OperatorsFilter
                  handleOperatorFilter={this.handleOperatorFilter}
                />
              </div>

              {/* hotel */}
              <div className="filter_item">
                <div className="bm_text_16 mb_7">{HOTEL}</div>
                {this.renderHotelServicesFilter(
                  services.filter((e) => e.group === HOTEL),
                )}
              </div>

              {/* for kids */}
              <div className="filter_item">
                <div className="bm_text_16 mb_7">{FOR_KIDS}</div>
                {this.renderHotelServicesFilter(
                  services.filter((e) => e.group === FOR_KIDS),
                )}
              </div>

              {/* room */}
              <div className="filter_item">
                <div className="bm_text_16 mb_7">{ROOM}</div>
                {this.renderHotelServicesFilter(
                  services.filter((e) => e.group === ROOM),
                )}
              </div>

              {/* territory */}
              <div className="filter_item">
                <div className="bm_text_16 mb_7">{TERRITORY}</div>
                {this.renderHotelServicesFilter(
                  services.filter((e) => e.group === TERRITORY),
                )}
              </div>

              {/* dop filters */}
              <div className="filter_item">
                <div className="bm_text_16 mb_7">{DOP}</div>
                {this.renderHotelServicesFilter(
                  services.filter((e) => e.group === DOP),
                )}
              </div>
            </div>
            <div className="tr_filters_buttons">
              <button
                className="tr_clear_filters_tablet"
                type="button"
                onClick={this.clearAllFilters}
                ref={(node) => {
                  this.tabletClearNode = node;
                }}
                disabled={filtersCount === 0}
              >
                <ResetFilters className="tr_clear_icon" />
                {CLEAR_FILTERS}
              </button>
              <button
                className="tr_tablet_show_button wm_text_14"
                type="button"
                onClick={this.handleModalClick}
              >
                {SHOW}
              </button>
            </div>
          </div>
        </div>
        <div className="container">{text}</div>
      </div>
    );
  }
}

ToursResult.propTypes = {
  adults: PropTypes.number.isRequired,
  kids: PropTypes.instanceOf(Array).isRequired,
  nightsFrom: PropTypes.number.isRequired,
  nightsTo: PropTypes.number.isRequired,
  destination: PropTypes.instanceOf(Object).isRequired,
  departureDate: PropTypes.instanceOf(Object).isRequired,
  depatureCity: PropTypes.instanceOf(Object).isRequired,
  selectedResorts: PropTypes.instanceOf(Array).isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
  changeSelectedResorts: PropTypes.func.isRequired,
  navigate: PropTypes.instanceOf(Object).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  text: PropTypes.object,
  currency: PropTypes.instanceOf(Object).isRequired,

  hotelsFilter: PropTypes.instanceOf(Array).isRequired,
  starsFilter: PropTypes.number.isRequired,
  starsFilterHover: PropTypes.number.isRequired,
  mealsFilter: PropTypes.instanceOf(Object).isRequired,
  ratingFilter: PropTypes.number.isRequired,
  beachLineFilter: PropTypes.number.isRequired,
  beachTypesFilter: PropTypes.instanceOf(Array).isRequired,
  hotelTypeFilter: PropTypes.instanceOf(Array).isRequired,
  hotelServicesFilter: PropTypes.instanceOf(Array).isRequired,
  onlyCharter: PropTypes.number.isRequired,
  directFlight: PropTypes.number.isRequired,
  operatorsFilter: PropTypes.instanceOf(Array).isRequired,
  countryFilter: PropTypes.instanceOf(Object),
  touristsSearchText: PropTypes.string.isRequired,
  datesSearchText: PropTypes.string.isRequired,

  changeStarsFilter: PropTypes.func.isRequired,
  changeMealsFilter: PropTypes.func.isRequired,
  changeStarsFilterHover: PropTypes.func.isRequired,
  changeRatingFilter: PropTypes.func.isRequired,
  changeBeachLineFilter: PropTypes.func.isRequired,
  changeBeachTypesFilter: PropTypes.func.isRequired,
  changeHotelTypeFilter: PropTypes.func.isRequired,
  changeHotelServicesFilter: PropTypes.func.isRequired,
  changeTouristsSearchText: PropTypes.func.isRequired,
  changeDatesSearchText: PropTypes.func.isRequired,
  changeOnlyCharter: PropTypes.func.isRequired,
  changeDirectFlight: PropTypes.func.isRequired,
  changeIsAllRegionsFilterTab: PropTypes.func.isRequired,
  changeIsAllOperatorsTab: PropTypes.func.isRequired,
  changeCurrency: PropTypes.func.isRequired,
  changeHotelsFilter: PropTypes.func.isRequired,
  changeOperatorsFilter: PropTypes.func.isRequired,
  changeDestination: PropTypes.func.isRequired,
  changeSelectedHotels: PropTypes.func.isRequired,
};

ToursResult.defaultProps = {
  text: '',
  countryFilter: null,
};

export default connect(mapStateToProps, {
  changeDestination,
  changeDepartureDate,
  setNightsFrom,
  setNightsTo,
  setAdults,
  setKids,
  changeDepatureCity,
  changeSelectedResorts,

  changeHotelsFilter,
  changeStarsFilter,
  changeStarsFilterHover,
  changeMealsFilter,
  changeRatingFilter,
  changeBeachLineFilter,
  changeBeachTypesFilter,
  changeHotelTypeFilter,
  changeHotelServicesFilter,
  changeOnlyCharter,
  changeDirectFlight,
  changeCurrency,
  changeRegionsOptions,
  changeIsAllRegionsFilterTab,
  changeOperatorsFilter,
  changeIsAllOperatorsTab,
  changeSelectedHotels,
  changeTouristsSearchText,
  changeDatesSearchText,
})(ToursResult);
